<template>
  <div>
    <!-- Dialog for Speech -->
    <v-dialog v-model="showVoice" max-width="1000">
      <v-card style="padding-block: 15px;" class="user-speech-box typing-box" color="secondary3">
        <v-card-text>
          <div style="padding-block: 15px; margin-block: 10px; line-height: 28px; font-size: 22px; font-family: Arimo, sans-serif; font-weight: normal; text-align: center;" class="text-center typing-box">
            <span>{{$store.state.message}}</span>
          </div>
        </v-card-text>
        <div v-show="loadModal == true">
          <Visualizer2 style="opacity: 0.8;" />
        </div>
      </v-card>
    </v-dialog>

    <!-- Canvas for Visualization -->
    <body onload="canvas">
<canvas id="bg"></canvas>
<canvas id="canvas" ></canvas>
</body>
  </div>
</template>
<script>
import Visualizer2 from './Visualizer2.vue';
export default {
  name: 'VoiceVisualizer',
  props: ['showVoice'],
  data: () => ({
    isClass: true,
    SpeechRecognition: null,
    recognition: null,
    visualizer: null,
  }),    
  components: {
    Visualizer2,
    },
    mounted() {
    this.initSpeechRecognition();
    this.initVisualizer();
  },
  methods: {
    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
      let instance = this;

      speech.onend = function() {
        console.log('Speech has finished');
        this.instance.micOn = false;
        instance.startSpeaking();
      }
    },
   },
  };
</script>



<style scoped src="../components/css/Style.css">
.dialogBox {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999; /* Ensure dialog is on top */
  display: flex;
  justify-content: center;
  align-items: center;  
}
.user-speech-box {
  z-index: 1000; /* Ensure dialog content is above the overlay */
  /* Other styles */
}
#canvas, #bg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10; /* Ensure canvas is below the dialog but above the rest of the content */
}
.animation7 {
  position: absolute;
  bottom: 28px;
  font-size: 15px; 
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 50%;
  color: #fff;
  animation-delay: 5s;
  -webkit-animation: fadeIn linear 15s forwards;
  -moz-animation: fadeIn linear 15s forwards;
  -o-animation: fadeIn linear 15s forwards;
  -ms-animation: fadeIn linear 15s forwards;
  animation: fadeIn linear 15s forwards;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
.user-speach-box {
  opacity: 1;
  height: 0px;
  border-radius: 10px;
  transform: translate(-0%, -50%);
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach-box {
  opacity: 1;
  max-width: 100%;
  bottom: 280px;
  height: 0px;
  float: inherit;
  left: 0%;
  border-radius: 10px;
  /* color: #85c739; */
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}

.typing-box {
  padding: 15px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 92%;
  margin-left: 50px;
  font-size: 20px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  text-align: center;
  background: rgba(20, 29, 41, 0.473);
  -webkit-animation: titleAnimation 15s infinite ease;
  -animation: titleAnimation 15s normal forwards ease-in-out;
}
 @keyframes glow4 {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 1px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 4px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
</style>